import gql from 'graphql-tag';

export const PreloadNotificationCountQuery = gql`
	query PreloadUnseenNotificationCountQuery {
		notifications {
			unseenNotificationCount
		}
	}
`;
